/*! Twire util - MIT license  */
import { v4 as uuidv4 } from 'uuid';

export default {
	
	html: function(text) {
		
		return text.replace(/&/g, "&amp;")
	               .replace(/</g, "&lt;")
	               .replace(/>/g, "&gt;")
	               .replace(/"/g, "&quot;")
	               .replace(/'/g, "&#039;");
		
	},
	generateGUID: function() {
		
		return uuidv4();
		
	},
	getUNIXTimestamp: function() {
		
		return Math.floor(Date.now() / 1000);
		
	},
	renderImgSizes: function(selector, attribute = 'width', drp = 2) {

		// 1. selector: any jquery selector, not assuming image so things like div.parent img can be selected
		// 2. attribute: 'width; or 'height'
		// 3. dpr: Device Pixel Ratio (DPR), allow fo any type of retina

		var $img = $(selector);

		// Whitelist attribute
		if (attribute == 'height') {

			attribute = 'height';

		} else {

			attribute = 'width';

		}
		
		$img.each(function() {

			var $this = $(this);

			// Get the native value
			var property = $this.data('twire-' + attribute);

			// Convert to retina value
			property = parseInt(property / drp);

			// Add as style=""
			$this.css(attribute, property + 'px');

		});

	}
	
};
